import React from 'react';
import { GeneralDialog } from 'sharedComponents/GeneralDialog';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { IconInfoFilled } from 'svgIcons/MotionPortalIcons';
import colors from 'theme/_colors.scss';
import { disconnectAssetRequest } from './actions';
import './style.scss';
import PropTypes from 'prop-types';
const DisconnectAssetComponent = ({ show, close, asset, gatewayID, onResetAssetInfo }) => {
    const { t: translate } = useTranslation();
    const dispatch = useDispatch();
    const content = <div className='disconnect_asset_dialog__content'>
        <div>{translate('ABB.Powertrain.Frontend.DisconnectAssetDescription')}</div>
    </div>;
    const getDisconnectGatewayTitle = <h1 className='disconnect_asset_dialog__title'>
        <IconInfoFilled color={colors.primaryInfo} />
        <span className='disconnect_asset_dialog__title-text'>{translate('ABB.Powertrain.Frontend.DisconnectedAssetTitle')}</span>
    </h1>;
    return (
        <GeneralDialog
            show={show}
            id='disconnect-asset-dialog'
            close={close}
            dialogClassName='disconnect_asset_dialog'
            closeButton={true}
            title={getDisconnectGatewayTitle}
            cancelButtonProps={{
                text: translate('ABB.Powertrain.Frontend.cancelLabel'),
            }}
            acceptButtonProps={{
                text: translate('ABB.Powertrain.Frontend.DisconnectLabel'),
                onClick: () => { dispatch(disconnectAssetRequest(asset?.assetId, gatewayID, onResetAssetInfo)); close(); },
            }}
            persistent={false}
        >
            {content}
        </GeneralDialog>
    );
};
DisconnectAssetComponent.propTypes = {
    show: PropTypes.bool,
    close: PropTypes.func,
    gatewayID: PropTypes.any,
    onResetAssetInfo: PropTypes.func,
};
export default DisconnectAssetComponent;
